/**
 * The Dive control for the globe HUD: shown while the selection is an antenna
 * of the loaded dataset with a usable location, disabled while a dive runs.
 */
import { useNavigate } from 'react-router';
import { PlaneLanding } from 'lucide-react';
import { TextButton } from '@/components/ui/primitives';
import { useLoader } from '@/features/loader/store';
import { useUI } from '@/state/store';
import { dive } from './controller';
import { createDiveDeps } from './deps';
import { useDive } from './store';

export function DiveButton() {
  const navigate = useNavigate();
  const antennaId = useUI((s) => s.selection.antennaId);
  const missionId = useUI((s) => s.selection.missionId);
  const antenna = useLoader((s) => (antennaId ? s.dataset?.antennas.find((a) => a.id === antennaId) : undefined));
  const phase = useDive((s) => s.phase);

  if (!antenna || missionId) return null;
  const { lat, lon } = antenna.location ?? {};
  if (typeof lat !== 'number' || typeof lon !== 'number' || !Number.isFinite(lat) || !Number.isFinite(lon)) return null;

  return (
    <TextButton
      onClick={() => void dive(antenna.id, createDiveDeps((path) => navigate(path)))}
      disabled={phase !== 'idle'}
      title={`Dive into the twin of ${antenna.shortName}`}
      className="flex items-center gap-1"
    >
      <PlaneLanding className="h-3.5 w-3.5" aria-hidden />
      Dive
    </TextButton>
  );
}
